<template>
    <div class="back panel">

        <form @submit.prevent="attemptRegister" id="register_form" v-if="!loading">
            <div id="error" class="alert alert-danger" v-if="error">
                {{ error }}
            </div>
            <h4>{{ $t('login.create.title') }}</h4>
            <p>
                {{ $t('login.create.desc') }}
            </p>
            <form-row :label="$t('label.name')">
                <form-input v-model="input.name" validate="required" name='Navn' :alias="$t('label.name')"></form-input>
            </form-row>
            <form-row :label="$t('label.email')">
                <form-input v-model="input.email" validate="required|email" name='Email' :alias="$t('label.email')"></form-input>
            </form-row>
            <form-row :label="$t('label.password')">
                <form-input type="password" v-model="input.password" validate="required" name="Adgangskode" :alias="$t('label.password')"></form-input>
            </form-row>
            <div class="panel-footer">
                <button class="btn pull-right" name="submitLogin" type="submit" tabindex="6">
                    <i class="icon-ok text-success"></i>
                    {{ $t('login.btn_create_account') }}
                </button>
                <button type="button" href="#" class="btn pull-right btn-space" tabindex="7"
                        @click="confirmBack">
                    <i class="icon-caret-left"></i>
                    {{ $t('btn_back') }}
                </button>
            </div>
        </form>
        <loader v-if="loading"></loader>
    </div>

</template>
<script>
    import formRow from "../layout/snippets/form-row.vue";
    import formInput from "../layout/snippets/form-input.vue";

    export default {
        components: {
            formRow,
            formInput
        },
        computed: {
            modified() {
                return this.input.name.length + this.input.email.length + this.input.password.length > 0;
            }
        },
        data() {
            return {
                error: null,
                loading: false,
                input: {
                    name: "",
                    email: "",
                    password: ""
                }
            }
        },
        $_veeValidate: {
            validator: 'new'
        },
        methods: {
            confirmBack() {
                if (!this.modified || confirm(this.$t('login.create.confirm_back'))) {
                    this.$emit('back');
                }
            },
            attemptRegister() {
                this.error = "";

                // Validate
                this.$validator.validateAll().then((result, resolve) => {
                    if (!result) {
                        resolve.reject();
                    }
                })
                    .then(this.save)
                    .catch(() => {});
            },
            save() {
                this.loading = true;

                this.$rest.post("/user", this.input)
                    .then(() => {
                        this.$emit('registered', {email: this.input.email, password: this.input.password});
                    })
                    .catch((request) => {
                        if(request.response.data && request.response.data.errors)
                        {
                            let error = request.response.data.errors[0];
                            if(error.rule === "Unique" && error.parameter === "email"){
                                this.error = this.$t('login.create.email_in_use');
                                return;
                            }
                        }
                        this.error = this.$t('login.create.generic_error');
                    })
                    .finally(() => {
                        this.loading = false;
                    })
            }
        }
    }
</script>
<style>
    #login-panel #register_form label.col-form-label {
        width: 100% !important;
        max-width: none;
        flex: none;
        text-align: left !important;
    }

    #login-panel #register_form div.form-group.row .col-6 {
        width: 100% !important;
        max-width: none;
        flex: none;
    }
</style>


// WEBPACK FOOTER //
// src/components/login/register.vue